import type { Application } from '@hotwired/stimulus';
import { Controller } from '@hotwired/stimulus';

export class TextExpandController extends Controller<HTMLElement> {
    declare readonly triggerCollapsedTarget: HTMLElement;
    declare readonly triggerExpandedTarget: HTMLElement;
    declare readonly detailsTarget: HTMLElement;
    declare readonly toggleTarget: HTMLButtonElement;

    static targets = ['triggerCollapsed', 'triggerExpanded', 'details', 'toggle'];

    static register(application: Application) {
        application.register('text-expand', this);
    }

    get expanded(): boolean {
        const state = this.toggleTarget.getAttribute('aria-expanded');
        return state === 'true';
    }

    connect(): void {
        this.toggleTarget.setAttribute('aria-expanded', 'false');
    }

    toggle() {
        this.toggleTarget.setAttribute('aria-expanded', this.expanded ? 'false' : 'true');
    }
}
